module.exports = __webpack_public_path__ + "img/make-brushes-2_cn.bc63c51.jpg";